enum NetworkGraphNodeType {
  RootTeam = 1,
  ParentTeam = 2,
  ChildTeam = 3,
  Role = 4,
  Member = 5,
}

export { NetworkGraphNodeType };
